<template>
    <div class="mortgage-calcnew__calcblock mortgage-calcnew__calcblock_scroll _front-side" :class="{'_front-side': !mobile, 'mortgage-calcnew__mobile': mobile}">
		<preloader v-show="loading"></preloader>
        <div class="mortgage-calculator-new__right-header _justify-content-between">
            <p class="mortgage-calculator-new__right-par gray-text-light">Платёж в месяц</p>
            <p class="mortgage-calculator-new__right-title">{{ resultsdata.monthlyPay | formatMoneyToInt }}</p>
        </div>
        <div class="_dflex _justify-content-between _align-items-center _mt-16">
            <p class="mortgage-calculator-new__right-par gray-text-light">Диапазон полной стоимости кредита <hint no-margin text="Сумма ваших реальных расходов по кредиту в период его действия, включая платежи по погашению основной суммы долга, уплаты процентов, страховой премии и иных расходов, следующих из договора" /></p>
            <p class="mortgage-calculator-new__right-title mortgage-calculator-new__right-title_min mortgage-calculator-new__right-title_range _mt-8">{{ range }}</p>
        </div>
        <div class="_dflex _justify-content-between _align-items-center _mt-16">
            <p class="mortgage-calculator-new__right-par gray-text-light">Ставка</p>
            <p class="mortgage-calculator-new__right-title mortgage-calculator-new__right-title_min">{{ resultsdata.rate | formatPercent }}</p>
        </div>
        <div class="_dflex _justify-content-between _align-items-center _mt-16">
            <p class="mortgage-calculator-new__right-par gray-text-light">Сумма кредита</p>
            <p class="mortgage-calculator-new__right-title mortgage-calculator-new__right-title_min">{{ resultsdata.loanAmount | formatMoneyToInt }}</p>
        </div>
        <div class="_dflex _justify-content-between _align-items-center _mt-16">
            <p class="mortgage-calculator-new__right-par gray-text-light">Срок кредита</p>
            <p class="mortgage-calculator-new__right-title mortgage-calculator-new__right-title_min">{{ years }}</p>
        </div>
        <div class="_dflex _justify-content-between _align-items-center _mt-16">
            <p class="mortgage-calculator-new__right-par gray-text-light">Необходимый доход</p>
            <p class="mortgage-calculator-new__right-title mortgage-calculator-new__right-title_min">{{ resultsdata.income  | formatMoneyToInt }}</p>
        </div>
        <div class="_mt-24">
            <mortgage-send-with-lk button-text="Подать заявку" additional-classes="_w-100 button_green"></mortgage-send-with-lk>
            <button class="button button_light _w-100 _mt-24" @click.prevent="$modal.show('paymentsShedule')">График платежей</button>
        </div>
        <div class="_mt-24">
            <p class="p4">*Предложение носит информационный характер и не является публичной офертой. Расчет суммы кредита осуществлен для Москвы/Московской области. Итоговые параметры кредита определяются при заключении договора</p>
        </div>
    </div>
</template>

<script>
import filters from '../../../assets/js/vue/filters';

export default {
    name: "MortgageCalculatorResults",
    props: {
        resultsdata: {
            type: Object
        },
        mobile: {
            type: Boolean,
            dafault: false
        },
        lkRedirect: {
            type: String,
            default: "",
        },
        auth: {
            type: Boolean,
            default: false,
        },
        familyRange: {
            type: String,
            default: "",
        },
        prefRange: {
            type: String,
            default: "",
        },
        buildingRange: {
            type: String,
            default: "",
        },
        readyRange: {
            type: String,
            default: "",
        },
        itRange: {
            type: String,
            default: "",
        },
        refinRange: {
            type: String,
            default: "",
        },
        houseRange: {
            type: String,
            default: "",
        },
        eastRange: {
            type: String,
            default: "",
        }
    },
    filters: {
        months: (value) => {
            return value === 1 ? `${value} месяц` : [2, 3, 4].includes(value) ? `${value} месяца` : `${value} месяцев`
        }
    },
    data() {
        return {
            filters: filters,
            comissionRebate: 0.02,
            range: '',
            loading: false,
        }
    },
    methods: {
        showModalPfr() {
            this.$emit('showPfrModal');
        },
        getRateRange() {
            if (this.$props.resultsdata.targetsCode === 'product_family') {
                this.range = this.$props.familyRange;
            }
            else if (this.$props.resultsdata.targetsCode === 'product_preferential') {
                this.range = this.$props.prefRange;
            }
            else if (this.$props.resultsdata.targetsCode === 'product_building') {
                this.range = this.$props.buildingRange;
            }
            else if (this.$props.resultsdata.targetsCode === 'product_ready') {
                this.range = this.$props.readyRange;
            }
            else if (this.$props.resultsdata.targetsCode === 'it_specialist') {
                this.range = this.$props.itRange;
            }
            else if (this.$props.resultsdata.targetsCode === 'product_refinancing') {
                this.range = this.$props.refinRange;
            }
            else if (this.$props.resultsdata.targetsCode === 'product_building_house') {
                this.range = this.$props.houseRange;
            }
            else if (this.$props.resultsdata.targetsCode === 'product_far_east') {
                this.range = this.$props.eastRange;
            }
        },
    },
    computed: {
        comission() {
            return this.$props.resultsdata.loanAmount * this.comissionRebate
        },
        benefit() {
            return ((this.$props.resultsdata.period * 12) * this.$props.resultsdata.rbBeforePay - this.$props.resultsdata.loanAmount)
            - ((this.$props.resultsdata.period * 12) * this.$props.resultsdata.monthlyPay - this.$props.resultsdata.loanAmount) - (this.$props.resultsdata.loanAmount * this.comissionRebate)
        },
        lkiClasses() {
            return this.$props.resultsdata.targetsCode === 'it_specialist' && this.$props.resultsdata.itIncomeError ? '_w-100 button-disabled button-disabled_withbg button_green' :'_w-100 button_green'
        },
        years() {
            if (this.$props.resultsdata.period % 12 === 0) {
                return this.filters.periodString(this.period / 12);
            }
            else {
                return `${this.filters.periodString(Math.floor(this.$props.resultsdata.period / 12))} ${this.$options.filters.months(this.$props.resultsdata.period % 12)}`
            }
        },
    },
    watch: {
        'resultsdata.targetsCode'() {
            this.getRateRange();
        }
    }
}
</script>
